import React, { useState } from 'react'
import { MotifFormField, MotifSearch } from '@ey-xd/motif-react'
import { avoidXSSattack } from 'utils/security'

const Search = (props: any) => {

    const [value, setValue] = useState('')
    return (
        <MotifFormField>
            <MotifSearch
                onChange={(e: any) => {e=avoidXSSattack(e); setValue(e.target.value)}}
                placeholder="Search for..."
                value={value}
                {...props}
            />
        </MotifFormField>
    )
}

export default Search